module.exports = __webpack_public_path__ + "3f10d99950e5e9b12d8dc17c38365a71.png";